import { BigidColorsV2 } from '@bigid-ui/components';
import { styled } from '@mui/styles';

export const StyledToken = styled('div')({
  margin: '18px auto',
  width: 60,
  height: 60,
  lineHeight: '60px',
  borderRadius: '50%',
  fontSize: 22,
  textAlign: 'center',
  background: BigidColorsV2.gray[150],
  fontWeight: 'bold',
});

export const StyledLink = styled('button')(({ theme }) => ({
  cursor: 'pointer',
  color: theme.vars.tokens?.bigid?.textLink,
  border: 'none',
  outline: 'none',
  backgroundColor: 'transparent',
  padding: 0,
  fontSize: 'inherit',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
